/// <amd-module name="Wit/Identity/Interfaces/WorkItemInterfaces" />
import { IdentityRef } from "VSS/Platform/Contracts/WebApi";

export interface WorkItemIdentityRef {
    distinctDisplayName: string;
    identityRef: IdentityRef;
}
